import {
  BulkActionContainerCol,
  Col,
  Table,
  TableActionBarRow,
} from "melco-ui";
import { useTranslation } from "react-i18next";

import { useState } from "react";
import { BulkActionCount } from "../table/BulkActionCount";

import { useUrlForward } from "../../hooks/urlforward/useUrlForward";
import { AddNewForwardDrawer } from "./drawer/AddNewForwardDrawer";
import { ControlcenterMelcoControlCenterModelsForwardLinkListItem } from "melco-shared-logic";
import { useTableSelection } from "../../hooks/table/useTableSelection";
import { BulkActionDeleteForwardsProps } from "./BulkActionDeleteForwards";

import { EditForwardDrawer } from "./drawer/EditForwardDrawer";
import { Search } from "../search/Search";
import { TableCellLink } from "../table/TableCellLink";
import { useRolesContext } from "../../hooks/roles/useRolesContext";

type UrlForwardListPropTypes = {
  openAddNewForwardDrawer: boolean;
  setAddNewForwardDrawerFunction: (v: boolean) => void;
};

export const UrlForwardList: React.FC<UrlForwardListPropTypes> = ({
  openAddNewForwardDrawer,
  setAddNewForwardDrawerFunction,
}) => {
  const { t } = useTranslation();
  const { roles } = useRolesContext();
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination,
    // filtersChange,
    refetch,
    //  searchQuery,
    searchQueryChange,
  } = useUrlForward();

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isEditDrawerOpen, setEditDrawerOpen] = useState(false);
  const [editForwardLinkDetails, setEditForwardLinkDetails] =
    useState<ControlcenterMelcoControlCenterModelsForwardLinkListItem>();

  const handleEditClick = (
    item: ControlcenterMelcoControlCenterModelsForwardLinkListItem
  ) => {
    setEditForwardLinkDetails(item);
    setEditDrawerAction(true);
  };

  const columns = [
    {
      title: t("url_forward.table.column.key"),
      key: "key",
      // dataIndex: "key",
      sorter: true,
      width: 180,
      render: (
        rowObj: ControlcenterMelcoControlCenterModelsForwardLinkListItem
      ) =>
        roles.URL_FORWARDS_EDIT ? (
          <TableCellLink
            onClick={() => {
              handleEditClick(rowObj);
            }}
            to={""}
          >
            {rowObj?.key}
          </TableCellLink>
        ) : (
          rowObj.key
        ),
    },
    {
      title: t("url_forward.table.column.source_url"),
      key: "key",
      // dataIndex: "key",
      sorter: true,
      render: (rowObj: any) => (
        <a
          href={
            process.env.REACT_APP_API_FORWARD_SOURCE_URL + "fwd/" + rowObj?.key
          }
          target="_blank"
          style={{ color: "#a91700", textDecoration: "underline" }}
        >
          {process.env.REACT_APP_API_FORWARD_SOURCE_URL + "fwd/" + rowObj?.key}
        </a>
      ),
    },
    {
      title: t("url_forward.table.column.forward_url"),
      key: "target_url",
      dataIndex: "target_url",
      sorter: true,
    },
    {
      title: t("url_forward.table.column.opened"),
      key: "opened",
      dataIndex: "opened",
      sorter: true,
      width: 100,
    },
    {
      title: t("url_forward.table.column.last_opened"),
      key: "last_opened",
      // dataIndex: "last_opened",
      sorter: true,
      width: 150,
      render: (rowObj: any) => (
        <div>
          <span>
            {rowObj.last_opened
              ? new Date(rowObj.last_opened).toLocaleString()
              : ""}
          </span>
        </div>
      ),
    },
  ];

  const setEditDrawerAction = (action: boolean) => {
    setEditDrawerOpen(action);
    refetch();
  };

  const setDrawerAction = (action: boolean) => {
    setDrawerOpen(action);
    setAddNewForwardDrawerFunction(action);
    refetch();
  };

  const { selectedRowKeys, setSelectedRowKeys, rowSelection, onRow } =
    useTableSelection<ControlcenterMelcoControlCenterModelsForwardLinkListItem>(
      () => { },
      {
        fixed: "left",
      }
    );

  return (
    <>
      <TableActionBarRow>
        <div></div>
        <Col>
          <Search
            onSearchInputChange={(query: string) => searchQueryChange(query)}
          />
        </Col>
        {roles.URL_FORWARDS_DELETE && (
          <BulkActionContainerCol>
            <BulkActionCount selectedCount={selectedRowKeys.length} />
            <BulkActionDeleteForwardsProps
              selectedRowKeys={selectedRowKeys}
              setSelectedRowKeys={setSelectedRowKeys}
              refetch={refetch}
            />
          </BulkActionContainerCol>
        )}
      </TableActionBarRow>
      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={pagination}
        rowKey="id"
        rowSelection={roles.URL_FORWARDS_DELETE ? rowSelection : undefined}
        onRow={onRow}
        noDataMessage={t("url_forward.designs.no_data_message")}
        errorComponent={errorComponent}
      />

      {roles.URL_FORWARDS_CREATE && (
        <AddNewForwardDrawer
          isDrawerOpen={openAddNewForwardDrawer}
          setDrawerOpen={setDrawerAction}
        />
      )}
      {roles.URL_FORWARDS_EDIT &&
        isEditDrawerOpen &&
        editForwardLinkDetails && (
          <EditForwardDrawer
            isDrawerOpen={isEditDrawerOpen}
            setDrawerOpen={setEditDrawerAction}
            ForwardLinkDetails={editForwardLinkDetails}
          />
        )}
    </>
  );
};
